import { DateTime } from 'luxon';
import { ComponentProps, forwardRef, useEffect, useState } from 'react';
import ReactDatePicker2, { registerLocale } from 'react-datepicker';
import './DatePicker.scss';
import vi from 'date-fns/locale/vi';
import { InputGroup } from 'react-bootstrap';
import IconCalendar from '../icons/IconCalendar';
import { getDisabledTimes } from '../utils/dateUtils';
import styled from 'styled-components';
registerLocale('vi', vi);

const StyledDatePicker = styled.div`
  .react-datepicker-wrapper {
    .form-control {
      padding-left: 8px;
      padding-right: 0;
    }
  }
`;

export const DatePicker = (props: ComponentProps<typeof ReactDatePicker2>) => {
  return (
    <StyledDatePicker>
      <ReactDatePicker2
        dateFormat="dd/MM/yyyy"
        timeCaption="Giờ"
        locale="vi"
        formatWeekDay={getWeekDay}
        className="form-control"
        customInput={<ReadonlyDateInput />}
        excludeTimes={getDisabledTimes(props.selected, props.minDate)}
        {...props}
      />
    </StyledDatePicker>
  );
};

export const ReadonlyDateInput = forwardRef(({ value, onClick }: any, ref: any) => (
  <InputGroup onClick={onClick}>
    <input className="form-control" value={value} readOnly ref={ref} />
    <InputGroup.Text>
      <IconCalendar />
    </InputGroup.Text>
  </InputGroup>
));

export default DatePicker;

export const getWeekDay = (d: string) => {
  switch (d) {
    case 'Thứ Hai':
      return 'T2';
    case 'Thứ Ba':
      return 'T3';
    case 'Thứ Tư':
      return 'T4';
    case 'Thứ Năm':
      return 'T5';
    case 'Thứ Sáu':
      return 'T6';
    case 'Thứ Bảy':
      return 'T7';
    case 'Chủ Nhật':
      return 'CN';
  }
};
